import { render } from "./StepWizardUpdate1.vue?vue&type=template&id=2554d882"
import script from "./StepWizardUpdate1.vue?vue&type=script&lang=js"
export * from "./StepWizardUpdate1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__